import { z } from 'zod';
import { dateRangeQuerySchema, uuidSchema } from './common.js';
export const reportKpisSchema = z.object({
    revenueCents: z.number(),
    depositsCents: z.number(),
    activeLeads: z.number(),
    openQuotesCount: z.number(),
    openQuotesValueCents: z.number(),
    jobsCompleted: z.number(),
    avgJobValueCents: z.number(),
});
export const revenueMonthlyPointSchema = z.object({ month: z.string(), revenueCents: z.number() });
export const revenueByServicePointSchema = z.object({ serviceName: z.string(), revenueCents: z.number(), jobCount: z.number() });
export const leadFunnelPointSchema = z.object({
    source: z.string(), total: z.number(), contacted: z.number(), qualified: z.number(), quoted: z.number(), won: z.number(), lost: z.number(),
});
export const employeePerformancePointSchema = z.object({
    userId: z.string().uuid(), fullName: z.string(), quotesCreated: z.number(), quotesSent: z.number(), quotesWon: z.number(),
    revenueCents: z.number(), jobsCompleted: z.number(), avgTurnaroundHours: z.number().nullable(),
});
export const creditUsagePointSchema = z.object({ day: z.string(), standardRenders: z.number(), hdRenders: z.number(), creditsSpent: z.number() });
export const reportsQuerySchema = dateRangeQuerySchema.extend({
    locationId: uuidSchema.optional(),
});
export const reportNameSchema = z.enum(['kpis', 'revenue-monthly', 'revenue-by-service', 'lead-funnel', 'employees', 'credits']);
export const reportExportSchema = z.object({
    report: reportNameSchema,
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
    locationId: uuidSchema.optional(),
    locale: z.enum(['en', 'zh-CN']).default('en'),
});
//# sourceMappingURL=reports.js.map